<template>
   <div id="footer">
       <p>Stay up to date with MA <a href="https://www.mass.gov/lists/covid-19-regulations-guidance" target="_blank">covid guidelines.</a></p>
       <p>Copyright 2020. Designed by Nicole Cote</p>
    </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="scss">
    #footer {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        background-color: #000;
        color: #FFF;
        margin-top: auto;

        p {
            margin: 0;

            a {
                color: #FFF;
            }
        }

        p:first-child {
            padding-bottom: 15px;
        }
    }
</style>
